import { render } from "./HospitalTeamSelect.vue?vue&type=template&id=ec33e252&ts=true"
import script from "./HospitalTeamSelect.vue?vue&type=script&lang=ts"
export * from "./HospitalTeamSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__